export const getCharAtName = (name) => {
    if (typeof name === 'string') {
        return name.trim().split(' ').map(word => word.charAt(0).toUpperCase()).join('');
    }
    return '';
};